import { FileText, CheckCircle, Banknote, Sparkles } from 'lucide-react';
import { Reveal } from './motion/Reveal';
import { StaggerGroup, StaggerItem } from './motion/Stagger';

export const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      icon: FileText,
      title: 'Conte o que aconteceu',
      description: 'É rapidinho! Em menos de 2 minutos você nos conta seu caso no WhatsApp ou formulário. Sem termos difíceis.',
    },
    {
      number: '2',
      icon: CheckCircle,
      title: 'A gente cuida de tudo',
      description: 'Nossa equipe analisa seus holerites e FGTS gratuitamente e calcula cada centavo devido. Relaxa!',
    },
    {
      number: '3',
      icon: Banknote,
      title: 'Você recebe o dinheiro',
      description: 'Quando ganharmos a causa ou o acordo sair, transferimos o valor direto pra sua conta. Você só paga se ganhar.',
    },
  ];

  return (
    <section
      id="como-funciona"
      data-testid="how-it-works-section"
      className="py-20 bg-white"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <Reveal delay={0.1} className="text-center mb-16">
          <div className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold mb-4">
            <Sparkles className="w-4 h-4" />
            <span>Super simples</span>
          </div>
          <h2
            data-testid="how-it-works-title"
            className="text-3xl md:text-4xl font-bold text-slate-900 mb-4"
          >
            Como funciona? <span className="text-blue-600">3 passos fáceis</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Receber o que é seu nunca foi tão fácil. Nós cuidamos de toda a
            burocracia enquanto você relaxa.
          </p>
        </Reveal>

        {/* Steps */}
        <StaggerGroup staggerDelay={0.15} startDelay={0.2} className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <StaggerItem
              key={index}
              data-testid={`step-${index}`}
              className="relative text-center"
            >
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-blue-100" />
              )}

              {/* Icon */}
              <div className="relative inline-flex mb-6">
                <div className="w-24 h-24 bg-blue-600 rounded-2xl flex items-center justify-center shadow-xl shadow-blue-600/30">
                  <step.icon className="w-10 h-10 text-white" />
                </div>
                <span className="absolute -top-2 -right-2 w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center text-blue-900 font-bold text-sm shadow-lg">
                  {step.number}
                </span>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed text-sm sm:text-base">
                {step.description}
              </p>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
